export const AML_NAV = 'aml';

export const AML_MATCH_STATUS = {
  CLEAR: 'clear',
  POSSIBLE: 'possible',
  STRONG: 'strong'
};

export const matchStatusLabel = (status) => {
  switch (status) {
    case 'strong':
      return 'Yönetici incelemesi';
    case 'possible':
      return 'İnceleme gerekli';
    default:
      return 'Temiz';
  }
};

export const matchStatusTone = (status) => {
  if (status === 'strong') return 'danger';
  if (status === 'possible') return 'warning';
  return 'success';
};

export const DEFAULT_AML_SETTINGS = {
  enabled: true,
  mode: 'monitor',
  screenBankMovements: true,
  screenInvoiceMatch: true,
  screenBeforeEdm: true,
  continuousMonitoring: true,
  listSyncEnabled: true,
  listSyncHourIstanbul: 3,
  fuzzyThreshold: 0.88,
  possibleMatchSendBehavior: 'allow',
  strongMatchSendBehavior: 'block'
};
